// DrawerNavigation.js

import React, { useState } from "react";
import { AiFillCloseCircle, AiOutlineClose } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";

const DrawerNavigation = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [dropdowns, setDropdowns] = useState({
    services: false,
    products: false,
  });
  const navigate = useNavigate();

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleDropdown = (dropdownName) => {
    setDropdowns((prevDropdowns) => ({
      // ...prevDropdowns,
      [dropdownName]: !prevDropdowns[dropdownName],
    }));
  };
  const handler = (link) => {
    setIsDrawerOpen(false);
    // navigate(link);
    window.location.href = link;
  };

  return (
    <div className="flex">
      {/* Drawer Toggle Button */}
      <button
        className="w-[20px] p-4  focus:outline-none text-black text-2xl transition duration-300"
        onClick={toggleDrawer}
      >
        ☰
      </button>

      {/* Drawer Overlay */}
      <div
        className={`fixed inset-0 bg-white bg-opacity-50 z-50 ${
          isDrawerOpen ? "visible" : "hidden"
        }`}
        onClick={toggleDrawer}
      ></div>

      {/* Drawer Content */}
      <div
        className={`fixed left-0 top-0 min-h-screen    z-50 bg-white text-balck w-64 transform transition-transform ease-in-out ${
          isDrawerOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <button
          onClick={() => setIsDrawerOpen(false)}
          className="float-right m-5"
        >
          <AiOutlineClose size={30} color="gray" />
        </button>
        <nav className="p-4 h-full ">
          {/* Your navigation links go here */}
          <ul>
            <li>
              <button
                onClick={() => handler("/")}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                Home
              </button>
            </li>
            <li>
              <button
                onClick={() => toggleDropdown("services")}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                Dresses
              </button>
              {/* First Nested Dropdown */}
              {dropdowns.services && (
                <ul className="ml-8 mt-2">
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Special Offer
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Casual Dresses
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Formal Dresses
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Summer Dresses
                    </button>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <button
                onClick={() => toggleDropdown("products")}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                Tops
              </button>
              {/* Second Nested Dropdown */}
              {dropdowns.products && (
                <ul className="ml-8 mt-2">
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Special Offer
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Blouses
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Cardigans
                    </button>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <button
                onClick={() => toggleDropdown("contact")}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                Skirts
              </button>
              {/* Third Nested Dropdown */}
              {dropdowns.contact && (
                <ul className="ml-8 mt-2">
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Special Offer
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Maxi Skirts
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Mini Skirts
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Fairy Long Skirts
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Short Skirts
                    </button>
                  </li>
                </ul>
              )}
            </li>

            <li>
              <button
                onClick={() => toggleDropdown("oneSets")}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                One-Sets
              </button>
              {/* Third Nested Dropdown */}
              {dropdowns?.oneSets && (
                <ul className="ml-8 mt-2">
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Special Offer
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Avery Sets
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Innlay Sets
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Cherry Sets
                    </button>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <button
                onClick={() => toggleDropdown("tShirts")}
                className="block py-2 px-4 bg-white w-full text-left"
              >
                T-Shirts
              </button>
              {/* Third Nested Dropdown */}
              {dropdowns?.tShirts && (
                <ul className="ml-8 mt-2">
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Special Offer
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Oversized Simple Tees
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Oversized Graphic Tees
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() =>
                        handler("https://yourstylistclothing.com/")
                      }
                      className="block p-2 hover:bg-slate-100"
                    >
                      Regular Fit Tees
                    </button>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default DrawerNavigation;
